import { render } from "./PerformanceDashboard.vue?vue&type=template&id=0726c5ce&scoped=true"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=js"

import "./PerformanceDashboard.vue?vue&type=style&index=0&id=0726c5ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0726c5ce"]])

export default __exports__